import React from 'react';
import { Grid } from '@mui/material';

import DiaryStatusContainer from '../containers/diary/DiaryStatusContainer';
import NewPage from '../components/NewPage';
import { getManagerMode } from '../common/util';

const DiaryPage = () => {
  const bManagerMode = getManagerMode();

  return (
    <NewPage title="음성일기">
      <Grid item xs={12}>
        <DiaryStatusContainer bManagerMode={bManagerMode} />
      </Grid>
    </NewPage>
  );
};

export default DiaryPage;
